import { put, all, takeEvery } from 'redux-saga/effects';

import { setPatient, setPatientSuccess } from './index';

function* setParamsFlow() {
  yield put(setPatientSuccess());
}

export default function* saga() {
  yield all([
    takeEvery(setPatient, setParamsFlow),
  ]);
}
